import { useState } from "react";
import { useParams } from "react-router-dom";
import {
  IoEllipsisHorizontal,
  IoSettingsOutline,
  IoTrashOutline,
} from "react-icons/io5";

import ReceiptBreadrumbs from "./components/ReceiptBreadcrumbs";
import ReceiptHeader from "./components/ReceiptHeader";
import ReceiptTable from "./components/ReceiptTable";
import ReceiptDelete from "./components/ReceiptDelete";

import Dropdown from "./../../components/common/Dropdown";
import Modal from "../../components/common/Modal";
import ReceiptForm from "./components/ReceiptForm";

const AccountReceipts = () => {
  const { id } = useParams();

  const [data, setData] = useState([]);
  const [account, setAccount] = useState(null);
  const [selected, setSelected] = useState(null);

  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [tableOptions, setTableOptions] = useState({
    year: "",
    quarter: "",
    search_query: "",
    current_page: 1,
    size: 10,
    sort_column: { path: "date_issued", order: "desc" },
  });

  const actions = (item) => {
    return [
      [
        {
          name: "Edit Info",
          icon: <IoSettingsOutline className="mr-3 text-gray-400" />,
          action: () => handleEdit(item),
        },
      ],
      [
        {
          name: "Delete Receipt",
          icon: <IoTrashOutline className="mr-3 text-red-500" />,
          action: () => handleDelete(item),
        },
      ],
    ];
  };

  const columns = [
    { path: "number", label: "OR No." },
    { path: "client_name", label: "Name" },
    { path: "client_type", label: "Type" },
    { path: "quarter_name", label: "Quarter" },
    { path: "gross_amount", label: "Gross Amt." },
    { path: "withheld_amount", label: "Withheld Amt." },
    { path: "net_amount", label: "Net Amt." },
    { path: "date_issued", label: "Date Issued" },
    {
      key: "actions",
      content: (data) => (
        <Dropdown items={actions(data)} icon={<IoEllipsisHorizontal />} />
      ),
    },
  ];

  const handleEdit = (item) => {
    const result = item ?? null;
    setSelected(result);
    setShowForm(!showForm);
  };

  const handleDelete = (item) => {
    const result = item ?? null;
    setSelected(result);
    setShowDelete(!showDelete);
  };

  const handleSuccess = (item) => {
    const index = data.findIndex((i) => i.id === item.id);

    if (index === -1) {
      setData([item, ...data]);
      return;
    }

    const items = [...data];
    items[index] = item;
    setData(items);
  };

  const handleDeleteSuccess = (item) => {
    const creditables = data.filter((i) => i.id !== item.id);
    setData(creditables);
    handleDelete();
  };

  return (
    <div className="px-6 lg:px-0">
      <ReceiptBreadrumbs id={id} account={account} setAccount={setAccount} />
      <div className="card p-8 mt-5">
        <ReceiptHeader
          id={id}
          data={data}
          account={account}
          options={tableOptions}
          onChange={setTableOptions}
          onSuccess={handleSuccess}
        />
        <ReceiptTable
          id={id}
          data={data}
          columns={columns}
          options={tableOptions}
          onChange={setTableOptions}
          setData={setData}
        />
      </div>
      <Modal
        size="6xl"
        title="Update Receipt"
        isOpen={showForm}
        isLoading={isLoading}
        onClose={handleEdit}
        borderTop
      >
        <ReceiptForm
          id={id}
          data={selected}
          isLoading={isLoading}
          setLoading={setIsLoading}
          setShowForm={setShowForm}
          onSuccess={handleSuccess}
        />
      </Modal>
      <Modal isLoading={isLoading} isOpen={showDelete} onClose={handleDelete}>
        <ReceiptDelete
          data={selected}
          setLoading={setIsLoading}
          onClose={handleDelete}
          onSuccess={handleDeleteSuccess}
        />
      </Modal>
    </div>
  );
};

export default AccountReceipts;
